const advancedSearchComponents = {};

export default advancedSearchComponents;
